import { z } from 'zod';
import {
  FamilyId,
  RecurringFeeAssignmentId,
  RecurringFeeDefinitionId,
  StudentId,
} from '../types/branded';

export const RecurringFeeAssignmentSchema = z.object({
  id: RecurringFeeAssignmentId,
  recurringFeeId: RecurringFeeDefinitionId,
  studentId: StudentId,
  tuitionAccountId: FamilyId,
  customAmount: z.number().positive().nullable().optional(),
  startDate: z.string().min(1),
  endDate: z.string().nullable().optional(),
  isActive: z.boolean().default(true),
  createdAt: z.string().min(1),
  updatedAt: z.string().min(1),
});
export type RecurringFeeAssignment = z.infer<typeof RecurringFeeAssignmentSchema>;

export const BulkAssignRecurringFeeErrorSchema = z.object({
  studentId: StudentId,
  reason: z.string().min(1),
});
export type BulkAssignRecurringFeeError = z.infer<typeof BulkAssignRecurringFeeErrorSchema>;

export const BulkAssignRecurringFeeResultSchema = z.object({
  assigned: z.number().int().nonnegative(),
  skipped: z.number().int().nonnegative(),
  errors: z.array(BulkAssignRecurringFeeErrorSchema).default([]),
});
export type BulkAssignRecurringFeeResult = z.infer<typeof BulkAssignRecurringFeeResultSchema>;
